import { useState } from 'react';
import { getColorI18nKey } from 'src/_shared/utils/getI18nKeys';
import { ToolOptionsProps } from '../ToolOptionsRenderer.types';
import { COLOR_TOOL_OPTION_CHOICES, COLOR_TOOL_PALETTE } from './color-tool-option/ColorToolOption.constants';
import { getColorToolOptionKey } from './color-tool-option/ColorToolOption.utils';


export const useColorOptions = ({ isPaperColor, options }: { isPaperColor: boolean; options: ToolOptionsProps[]; }) => {
  const [colorSelected, setColorSelected] = useState(() => {
    const yesColorOption = options.find(
      (option: ToolOptionsProps) => option.productOptionChoiceCode === COLOR_TOOL_OPTION_CHOICES.YES ||
        (isPaperColor && option.productOptionChoiceCode === '')
    );
    return yesColorOption?.choiceDetails?.color?.toLowerCase();
  });

  const noColorOption = options.find(
    (option: ToolOptionsProps) => option.productOptionChoiceCode !== COLOR_TOOL_OPTION_CHOICES.YES
  );

  const yesColorOption = options.find(
    (option: ToolOptionsProps) => option.productOptionChoiceCode === COLOR_TOOL_OPTION_CHOICES.YES ||
      (isPaperColor && option.productOptionChoiceCode === '')
  );

  const colorPaletteOptions = Object.values(COLOR_TOOL_PALETTE).map((color: string) => {
    return {
      ...yesColorOption,
      selected: color === yesColorOption?.choiceDetails?.color?.toLowerCase(),
      choiceDetails: { color },
      titleKey: getColorI18nKey(getColorToolOptionKey(color)),
    };
  });

  return {
    colorOptions: isPaperColor || !noColorOption ? colorPaletteOptions : [noColorOption, ...colorPaletteOptions],
    setColorSelected,
    colorSelected,
  };
};
